import * as React from 'react';
import type { DataValue } from 'react-apollo';
import { graphql } from 'react-apollo';

import type { ProgramUserCredits_ProgramEnrollmentId as ProgramEnrollmentId } from '__generated__/graphql-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import Query from 'bundles/internal-enterprise/components/queries/ProgramMembershipCredits.graphql';
import type {
  ProgramMembershipCreditsQueryQuery,
  ProgramMembershipCreditsQueryQueryVariables,
} from 'bundles/internal-enterprise/components/queries/__generated__/ProgramMembershipCredits';
import { formatEnumString } from 'bundles/internal-enterprise/utils/utils';

import _t from 'i18n!nls/internal-enterprise';

type PropsFromCaller = {
  programMembershipId: string;
};

type PropsFromGraphql = {
  data: DataValue<ProgramMembershipCreditsQueryQuery, ProgramMembershipCreditsQueryQueryVariables>;
};

type Props = PropsFromGraphql;

const ProgramMembershipCredits = ({ data }: Props) => {
  // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const programUserCredits = data.ProgramUserCredits?.queryByProgramEnrollmentIds.edges?.[0].node;

  if (programUserCredits?.isLimited) {
    return (
      <div className="rc-ProgramMembershipCredits">
        <FormattedMessage
          message={_t('Yes ({limitReason})')}
          limitReason={
            programUserCredits.coursesRemainingReason
              ? formatEnumString(programUserCredits.coursesRemainingReason)
              : _t('Unknown')
          }
        />
        <br />
        <FormattedMessage
          message={_t('Courses remaining: {coursesRemaining, number}')}
          coursesRemaining={programUserCredits.coursesRemaining}
        />
        <br />
        <FormattedMessage
          message={_t('Total allocated courses: {totalAllocatedCourses, number}')}
          totalAllocatedCourses={programUserCredits.totalAllocatedCourses}
        />
      </div>
    );
  } else {
    return <span>No</span>;
  }
};

export default graphql<
  PropsFromCaller,
  ProgramMembershipCreditsQueryQuery,
  ProgramMembershipCreditsQueryQueryVariables,
  PropsFromGraphql
>(Query, {
  options: ({ programMembershipId }) => {
    const [userId, programId] = programMembershipId.split('~');
    const programEnrollmentId: ProgramEnrollmentId = {
      userId: Number(userId),
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      programId,
    };
    return {
      variables: {
        programEnrollmentIds: [programEnrollmentId],
      },
      context: { clientName: 'gatewayGql' },
    };
  },
})(ProgramMembershipCredits);
